/**
 * Message catalogue typing.
 *
 * Every area file exports its English messages; the matching Spanish file is typed as the
 * English shape, so TypeScript rejects missing or extra keys. Messages are strings or
 * functions (for interpolation and plurals).
 *
 * Voice rule (docs/research/06 §6.3): every string is a plain label. Optional decorative
 * "flavor" lines live under a separate `flavor` key per area; a locale may leave any of them
 * out, and the UI then shows none. Flavor never goes on buttons, errors, consent, privacy or
 * moderation text.
 */
export type Localized<T extends { flavor: object }> = Omit<T, 'flavor'> & {
  flavor: Partial<T['flavor']>
}

export type Lang = 'en' | 'es'

export const LANGS: readonly Lang[] = ['en', 'es']
